import React, { useState } from 'react';
import { useAnalyticsTodos } from './useAnalyticsTodos';

export default function AnalyticsTodo({ demoTodos = null }) {
  const { todos, setTodos } = useAnalyticsTodos({ enabled: !demoTodos });
  const [newTitle, setNewTitle] = useState('');
  const [adding,   setAdding]   = useState(false);

  const toggle = (id) => { if (!demoTodos) setTodos(ts => ts.map(t => t.id === id ? { ...t, done: !t.done } : t)); };
  const remove = (id) => { if (!demoTodos) setTodos(ts => ts.filter(t => t.id !== id)); };

  const addTodo = () => {
    if (demoTodos || !newTitle.trim()) return;
    const t = { id: `t_${Date.now()}`, title: newTitle.trim(), due: 'Offen', pri: 'normal', done: false };
    setTodos(ts => [...ts, t]);
    setNewTitle('');
    setAdding(false);
  };

  const visible = demoTodos ?? todos;

  return (
    <div className="an-card">
      <div className="an-todo-list">
        {visible.map(t => (
          <div key={t.id} className={`an-todo${t.done ? ' an-todo--done' : ''}`} onClick={() => toggle(t.id)}>
            <div className="an-todo-check">
              {t.done && (
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
            <div className="an-todo-body">
              <div className="an-todo-title">{t.title}</div>
              <div className="an-todo-meta">
                <span>{t.due}</span>
                {t.pri === 'urgent' && <span className="an-todo-pill an-todo-pill--urgent">Dringend</span>}
                {t.pri === 'amber'  && <span className="an-todo-pill an-todo-pill--amber">Wichtig</span>}
              </div>
            </div>
            <button
              className="an-todo-del"
              onClick={e => { e.stopPropagation(); remove(t.id); }}
              title="Löschen"
            >×</button>
          </div>
        ))}

        {!demoTodos && (adding ? (
          <div className="an-todo-new">
            <input
              className="an-todo-new-input"
              autoFocus
              value={newTitle}
              onChange={e => setNewTitle(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') addTodo(); if (e.key === 'Escape') setAdding(false); }}
              placeholder="Neue Aufgabe…"
            />
            <button className="an-todo-new-save" onClick={addTodo}>Hinzufügen</button>
          </div>
        ) : (
          <button className="an-todo-add" onClick={() => setAdding(true)}>
            <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
              <path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            Aufgabe hinzufügen
          </button>
        ))}
      </div>
    </div>
  );
}
